import propertyOf from 'lodash/propertyOf';

export async function loadScriptInHead({ src, async = true, defer = false }) {
    const script = document.createElement('script');
    script.type = 'text/javascript'; 
    script.defer = Boolean(defer); 
    script.async = Boolean(async);
    script.src = src;
    document.head.appendChild(script);

    return new Promise(function waitForScriptLoad(resolve, reject) {
        script.onload = function onload() {
            resolve();
        };
        script.onerror = function onerror(error) {
            reject(error);
        };
    });
}

/**
 * Resolves when an expected property is present on window
 *  
 * @param {String} propertyPath 
 * @returns {Promise}
 * 
 * @example
 * waitForPropertyOnWindow('jQuery.noConflict')
 */
export async function waitForPropertyOnWindow(propertyPath, maxNumberOfPolls) {
    const accessor = propertyOf(window);
    let polls = 0;
    let interval;

    return new Promise(function waitForProperty(resolve, reject) {
        interval = setInterval(function() {
            polls += 1;
            if (accessor(propertyPath)) {
                clearInterval(interval);
                resolve();
            }
            if (maxNumberOfPolls && maxNumberOfPolls === polls) {
                reject(new Error(`Could not find property ${propertyPath}`));
            }
        }, 1000);
    });
}
